<template>
    <div id="app">
        <h1>{{name}}</h1>
    </div>
</template>

<script>
export default {
    name: 'About',
    data() {
        return{
            name: "About"
        }
    }
}
</script>





// WEBPACK FOOTER //
// src/components/About.vue